import Base from '../base';

class Files extends Base {
	attachFile(data) {
		const { id, type, field, file } = data;
		let formData = new FormData();
		formData.append('file', data.file);
		const api = this._api
			.url(`/binary/upload?type=${type}&id=${id}&field=${field}`)
			.data(file)
			.POST;
		return this.request(api);
	}

	uploadDocument(file) {
		let formData = new FormData();
		formData.append('file', file);

		const api = this._api
			.url('/binary/upload/document')
			.data(formData)
			.POST;
		return this.request(api);
	}

	downloadDocument(hash) {
		const api = this._api
			.url(`/binary/download/${hash}`)
			.options({
				responseType: 'blob'
			})
			.GET;
		return this.requestWithHeaders(api);
	}
}

export default new Files();

